import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { updateProps } from '../../../stores/newsfeed/actions';
import ProfileImage from '../../app-bar/profile-image';
import { FontIcon } from 'material-ui';
const logoGlobeSrc = require('../../../../www/images/tourconnect-logo-globe.svg');
import HomeIcon from 'material-ui/svg-icons/action/view-day';
import R from 'ramda';

const propTypes = {
  selectedLeftNav: PropTypes.string,
  updateProp: PropTypes.func,
  newsfeedReducer: PropTypes.object,
  profileImageUrl: PropTypes.string,
  companyName: PropTypes.string,
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  changeNewsfeedFilter: PropTypes.func,
  isAdmin: PropTypes.bool,
};

class LeftNav extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  changeLeftNav = (selectedValue, filter, filterType) => {
    const {
      selectedLeftNav,
      changeNewsfeedFilter,
      updateProp,
    } = this.props;
    if (selectedLeftNav !== selectedValue) {
      updateProp({ selectedLeftNav: selectedValue });
      changeNewsfeedFilter(filter, filterType);
    }
  };

  render() {
    const {
      newsfeedReducer,
      profileImageUrl,
      companyName,
      email,
      firstName,
      lastName,
      isAdmin,
    } = this.props;

    const isSelected = (text) => R.propEq('selectedLeftNav', text, newsfeedReducer);

    const textStyle = (text) => ({
      fontWeight: isSelected(text) ? '600' : '',
      fontSize: '15px',
      margin: '1px 0 0 8px',
      fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
      color: 'rgba(0, 0, 0, 0.54)',
      cursor: 'pointer',
    });

    const userName = () => (
      <div style={{ display: 'inline-block', width: '100%', height: '50px', cursor: 'pointer', marginBottom: '25px' }} onTouchTap={() => this.context.router.push('/profile')}>
        <span style={{ float: 'left' }}>
          <ProfileImage
            className="profile-link-image"
            companySlugName={companyName || email}
            imageUrl={profileImageUrl}
          />
        </span>
        <span style={{ float: 'left', margin: '10px', fontSize: '16px' }}>{firstName || lastName ? `${firstName} ${lastName}` : email}</span>
      </div>
    );

    const newFeedLink = () => (
      <div onTouchTap={() => this.changeLeftNav('News Feed', null, null)} style={{ backgroundColor: isSelected('News Feed') ? '#e7e8ea' : '' }} className="nav-add-hover">
        <HomeIcon color="gray"/>
        <span style={textStyle('News Feed')}>Home</span>
      </div>
    );

    const categories = [
      { text: 'Network Updates', icon: logoGlobeSrc, value: 'tourconnect' },
      { text: 'New Location', icon: 'tc-icon-location_on', iconColor: 'gray', value: 'new_location' },
      { text: 'New Product', icon: 'tc-icon-card_travel', iconColor: '#e397e3', value: 'new_product' },
      { text: 'New Membership', icon: 'tc-icon-verified_user', iconColor: '#97E397', value: 'new_membership' },
    ];

    const listCategories = () => (
      (isAdmin ? categories.concat([{ text: 'Admin', icon: 'tc-icon-portrait', iconColor: 'rgb(255, 64, 129)', value: 'general' }]) : categories).map((item, i) => {
        const divStyle = { margin: '7px 0px', backgroundColor: isSelected(item.text) ? '#e7e8ea' : '' };
        if (item.text === 'Network Updates') {
          return (
            <div
              onTouchTap={() => this.changeLeftNav(item.text, item, 'category')}
              key={i}
              style={divStyle}
              className="nav-add-hover"
            >
              <img src={logoGlobeSrc} width="21" style={{ display: 'inline-flex', verticalAlign: 'top' }}/>
              <span style={textStyle(item.text)}>{item.text}</span>
            </div>
          );
        }
        return (
          <div onTouchTap={() => this.changeLeftNav(item.text, item, 'category')} key={i} style={divStyle} className="nav-add-hover">
            <FontIcon color={item.iconColor} className={item.icon} style={{ fontSize: '20px' }}/>
            <span style={textStyle(item.text)}>{item.text}</span>
          </div>
        );
      })
    );

    return (
      <div style={{ padding: '0 10px' }}>
        {
          // userName()
        }
        {newFeedLink()}
        <div style={{ width: '100%', marginTop: '15px' }}>
          <div style={{ fontWeight: 600 }}>Featured Categories</div>
          {listCategories()}
        </div>
      </div>
    );
  }
}

LeftNav.propTypes = propTypes;

const mapStateToProps = ({ user, newsfeed }) => ({
  profileImageUrl: user.getIn(['company', 'profileImageUrl']),
  companyName: user.getIn(['company', 'companyName']),
  email: user.getIn(['user', 'email']),
  firstName: user.getIn(['user', 'firstName']),
  lastName: user.getIn(['user', 'lastName']),
  newsfeedReducer: newsfeed.toJS(),
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateProps(...args)),
});

LeftNav.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeftNav);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/leftNav/container.jsx